const map = {
	"./18_yas.svg": 7486,
	"./arrow_down.svg": 7379,
	"./arrow_up.svg": 684,
	"./author-comments-white.svg": 50483,
	"./author-comments-yellow.svg": 67580,
	"./canli_zirve_badge.svg": 98601,
	"./fill.svg": 79570,
	"./filter_xg.svg": 14313,
	"./following_non_login.svg": 86716,
	"./general_warning.svg": 66014,
	"./guide-icon.svg": 14043,
	"./hand-okey-icon.svg": 72239,
	"./hm_close.svg": 82017,
	"./hm_open.svg": 76451,
	"./ic-alert.svg": 39960,
	"./ic-arrow-up-white.svg": 63349,
	"./ic-back-green.svg": 36885,
	"./ic-back-white.svg": 63123,
	"./ic-bahis-yap-green.svg": 54200,
	"./ic-bahis-yap.svg": 18186,
	"./ic-betslip-settings.svg": 65081,
	"./ic-bilyonertv-v2.svg": 25617,
	"./ic-birthday.svg": 86689,
	"./ic-canli-bahis-green.svg": 36825,
	"./ic-canli-bahis.svg": 32943,
	"./ic-canli-izle-green.svg": 89092,
	"./ic-canli-izle.svg": 59342,
	"./ic-canli-sonuclar-green.svg": 45509,
	"./ic-canli-sonuclar.svg": 49283,
	"./ic-circle-close-gray-v2.svg": 59612,
	"./ic-close-gray-solid.svg": 23320,
	"./ic-close-or-delete-white.svg": 30604,
	"./ic-close-or-delete.svg": 91324,
	"./ic-close.svg": 9458,
	"./ic-combined-shape.svg": 63331,
	"./ic-decrease.svg": 30878,
	"./ic-down.svg": 5086,
	"./ic-drag-drop-red.svg": 24212,
	"./ic-drag-drop.svg": 35630,
	"./ic-dynamic-date-filled.svg": 3155,
	"./ic-dynamic-date-green.svg": 14284,
	"./ic-dynamic-date.svg": 28342,
	"./ic-failed.svg": 22425,
	"./ic-fil-author-comments-light-grey.svg": 4837,
	"./ic-fil-live-light-grey.svg": 33471,
	"./ic-fil-search-white.svg": 25720,
	"./ic-fil-tv-light-green.svg": 21683,
	"./ic-fil-tv-light-grey.svg": 627,
	"./ic-fil-tv-light-white.svg": 69721,
	"./ic-filter-collapse-v2.svg": 22433,
	"./ic-filter-percentage-v2.svg": 43726,
	"./ic-filter-white.svg": 66948,
	"./ic-full-screen.svg": 43474,
	"./ic-game-arrow-right-white.svg": 93001,
	"./ic-game-arrow-right.svg": 43989,
	"./ic-game-arrow-rightwtext.svg": 1205,
	"./ic-gift-catalog.svg": 29638,
	"./ic-hide-pass.svg": 60840,
	"./ic-increase.svg": 72393,
	"./ic-kuponlarim-green.svg": 12978,
	"./ic-kuponlarim.svg": 57544,
	"./ic-like.svg": 46491,
	"./ic-next-nextgen-home-horse-race.svg": 13347,
	"./ic-pause-v2.svg": 13653,
	"./ic-play-v2.svg": 47405,
	"./ic-player-analyz-v2.svg": 86934,
	"./ic-ratio-white.svg": 58867,
	"./ic-report-white.svg": 6368,
	"./ic-search-white.svg": 33866,
	"./ic-show-pass.svg": 36226,
	"./ic-sign-up.svg": 27905,
	"./ic-statistics-off.svg": 46527,
	"./ic-statistics-on.svg": 36291,
	"./ic-success-noti.svg": 90040,
	"./ic-success.svg": 19351,
	"./ic-suspend-lock.svg": 95978,
	"./ic-thumbs-up.svg": 6685,
	"./ic-tv-circle-green.svg": 95863,
	"./ic-tv-circle-white.svg": 61125,
	"./ic-tv-circle.svg": 3505,
	"./ic-up-icon.svg": 249,
	"./ic-vaix-search-close-btn.svg": 42123,
	"./ic-vaix-search.svg": 32527,
	"./ic-vs-after-search-all-black.svg": 37211,
	"./ic-vs-after-search-all.svg": 72797,
	"./ic-vs-empty-arrow.svg": 15863,
	"./ic-waiting.svg": 24995,
	"./ic_account_logout.svg": 48430,
	"./ic_action_three_dots.svg": 6602,
	"./ic_add_account.svg": 27549,
	"./ic_ag_nav.svg": 59950,
	"./ic_agf_info.svg": 4681,
	"./ic_alert_error.svg": 25877,
	"./ic_alert_triangle.svg": 44457,
	"./ic_aninda_bilyoner.svg": 53636,
	"./ic_aninda_para_yatir_video.svg": 96472,
	"./ic_announcement.svg": 8665,
	"./ic_app_store.svg": 84803,
	"./ic_arrow_down-sportoto.svg": 44269,
	"./ic_arrow_down.svg": 95650,
	"./ic_arrow_down_black.svg": 85518,
	"./ic_arrow_down_gray.svg": 60688,
	"./ic_arrow_down_white.svg": 62100,
	"./ic_arrow_down_white_v2.svg": 61071,
	"./ic_arrow_left.svg": 30921,
	"./ic_arrow_right.svg": 36180,
	"./ic_arrow_right_dark.svg": 25171,
	"./ic_arrow_right_dark_gray.svg": 46891,
	"./ic_arrow_right_dark_green.svg": 14159,
	"./ic_arrow_right_gray.svg": 12938,
	"./ic_arrow_right_green.svg": 67696,
	"./ic_arrow_up.svg": 77649,
	"./ic_arrow_up_dark.svg": 52488,
	"./ic_attention_orange.svg": 36575,
	"./ic_author_filter.svg": 5534,
	"./ic_author_icon.svg": 9579,
	"./ic_author_rectangle.svg": 57039,
	"./ic_authors_down.svg": 95355,
	"./ic_authors_up.svg": 47444,
	"./ic_b_logo.svg": 22424,
	"./ic_back.svg": 78605,
	"./ic_back_button_v2.svg": 78063,
	"./ic_back_icon.svg": 66331,
	"./ic_back_white.svg": 81575,
	"./ic_bahista_eye_open.svg": 53297,
	"./ic_bahista_probability_balanced.svg": 5707,
	"./ic_bahista_probability_high.svg": 20403,
	"./ic_bahista_probability_surprise.svg": 70074,
	"./ic_bahista_shines.svg": 69111,
	"./ic_bell_selected.svg": 43557,
	"./ic_bell_selected_white.svg": 14639,
	"./ic_bell_unselected.svg": 94364,
	"./ic_bell_unselected_white.svg": 10470,
	"./ic_bell_white.svg": 88249,
	"./ic_bet_down.svg": 56800,
	"./ic_bet_up.svg": 70131,
	"./ic_bets_changes_stack_circle.svg": 31510,
	"./ic_bets_changes_stack_circleV2.svg": 62654,
	"./ic_betslip_horse.svg": 54065,
	"./ic_bilyoner.svg": 5552,
	"./ic_bilyoner_logo.svg": 36382,
	"./ic_bilyoner_logo_circle.svg": 81053,
	"./ic_bilyonerganyan.svg": 94410,
	"./ic_bilyonertv.svg": 84842,
	"./ic_block_user.svg": 8483,
	"./ic_bullhorn_green.svg": 68020,
	"./ic_button_lost.svg": 47505,
	"./ic_button_won.svg": 59429,
	"./ic_calendar.svg": 36742,
	"./ic_call_customer_service.svg": 11735,
	"./ic_campaigns_green_new.svg": 9262,
	"./ic_caret_down_red.svg": 42284,
	"./ic_caret_up_green.svg": 73079,
	"./ic_chance_games.svg": 94836,
	"./ic_chance_games_play-again.svg": 98,
	"./ic_chance_games_refresh.svg": 99744,
	"./ic_change_player.svg": 92780,
	"./ic_check_circle.svg": 72599,
	"./ic_check_filled.svg": 36751,
	"./ic_check_green.svg": 62328,
	"./ic_check_main_green.svg": 60136,
	"./ic_check_white.svg": 71366,
	"./ic_checkmark.svg": 75151,
	"./ic_chevron_down.svg": 99916,
	"./ic_chevron_right.svg": 90878,
	"./ic_chevron_right_current.svg": 83320,
	"./ic_chronometer.svg": 88188,
	"./ic_circle-facebook.svg": 345,
	"./ic_circle-twitter.svg": 71766,
	"./ic_circle-whatsapp.svg": 37643,
	"./ic_clear_filter.svg": 4636,
	"./ic_clock_schedule_time.svg": 71870,
	"./ic_close.svg": 73352,
	"./ic_close_accordion.svg": 81379,
	"./ic_close_accordionGray.svg": 74898,
	"./ic_close_accordion_colored.svg": 70780,
	"./ic_close_circle_black.svg": 85591,
	"./ic_close_circle_dark.svg": 24106,
	"./ic_close_comment.svg": 92938,
	"./ic_close_dark.svg": 30447,
	"./ic_close_delete.svg": 99798,
	"./ic_close_delete_light_green.svg": 1807,
	"./ic_close_delete_white.svg": 73448,
	"./ic_close_gray.svg": 82246,
	"./ic_close_red.svg": 18508,
	"./ic_close_white.svg": 11954,
	"./ic_comment_author.svg": 56039,
	"./ic_comment_fill.svg": 92917,
	"./ic_comment_green.svg": 41207,
	"./ic_comment_stack_circle.svg": 79205,
	"./ic_comments.svg": 98322,
	"./ic_confirm_check_green.svg": 58917,
	"./ic_confirm_error.svg": 18567,
	"./ic_copy.svg": 59283,
	"./ic_copy_black.svg": 85527,
	"./ic_copy_header.svg": 9225,
	"./ic_copy_new.svg": 77308,
	"./ic_copy_white.svg": 6637,
	"./ic_coupon_detail.svg": 48062,
	"./ic_coupon_order.svg": 71151,
	"./ic_date_picker.svg": 17173,
	"./ic_decline_filled.svg": 22009,
	"./ic_default_bilyoner_logo.svg": 64580,
	"./ic_default_jockey.svg": 20419,
	"./ic_deposit_money.svg": 96295,
	"./ic_director.svg": 81564,
	"./ic_disallowed.svg": 64072,
	"./ic_double_arrow.svg": 45277,
	"./ic_down.svg": 86496,
	"./ic_down_arrow.svg": 67850,
	"./ic_down_arrow_raffle.svg": 95252,
	"./ic_down_direction.svg": 72382,
	"./ic_edit_account.svg": 74916,
	"./ic_ekuri_horse.svg": 52632,
	"./ic_empty_star.svg": 44394,
	"./ic_empty_transactions.svg": 66649,
	"./ic_error_modal.svg": 68992,
	"./ic_eye_close.svg": 16434,
	"./ic_eye_open.svg": 58862,
	"./ic_facebook2.svg": 40218,
	"./ic_fast_deposit_cancel_error.svg": 60337,
	"./ic_fast_deposit_cancel_error_dark.svg": 75336,
	"./ic_fast_deposit_cancel_info.svg": 18973,
	"./ic_fast_deposit_close.svg": 89160,
	"./ic_fast_deposit_iban_close.svg": 20645,
	"./ic_fast_deposit_info.svg": 59496,
	"./ic_fast_deposit_send_payment.svg": 67465,
	"./ic_fast_deposit_transactions_empty.svg": 91497,
	"./ic_filter_active.svg": 88287,
	"./ic_filter_check.svg": 6551,
	"./ic_filter_favourite_v2.svg": 50469,
	"./ic_filter_filter.svg": 31791,
	"./ic_filter_htw.svg": 35008,
	"./ic_filter_htw_active.svg": 36149,
	"./ic_filter_mbs1.svg": 27384,
	"./ic_filter_percent.svg": 35448,
	"./ic_filter_rapid_games.svg": 76569,
	"./ic_filter_transparan_dark.svg": 16822,
	"./ic_filter_v2.svg": 47549,
	"./ic_finish_flag.svg": 21386,
	"./ic_finish_flag_green.svg": 61054,
	"./ic_fire.svg": 12664,
	"./ic_first_user.svg": 35388,
	"./ic_follow_notif.svg": 77940,
	"./ic_following_user.svg": 26449,
	"./ic_football-pitch.svg": 48386,
	"./ic_forgot_password.svg": 6243,
	"./ic_forgot_password_otp.svg": 58025,
	"./ic_galaxy_store.svg": 64142,
	"./ic_game_info.svg": 91157,
	"./ic_game_not_found.svg": 22921,
	"./ic_game_percent_white.svg": 70778,
	"./ic_game_search_clear.svg": 57739,
	"./ic_game_selected_thick.svg": 56276,
	"./ic_games_search.svg": 21591,
	"./ic_google_play.svg": 94058,
	"./ic_green-edit.svg": 78822,
	"./ic_green-plus.svg": 84774,
	"./ic_green_arrow_down.svg": 64710,
	"./ic_green_arrow_up.svg": 69930,
	"./ic_green_info.svg": 64220,
	"./ic_hamburger.svg": 30641,
	"./ic_hamburger_green.svg": 91357,
	"./ic_hamburger_white.svg": 87563,
	"./ic_header_left.svg": 27221,
	"./ic_header_right.svg": 54616,
	"./ic_header_sync.svg": 78395,
	"./ic_heart.svg": 76440,
	"./ic_heart_empty.svg": 24586,
	"./ic_help.svg": 87429,
	"./ic_help_white.svg": 71311,
	"./ic_hide.svg": 16884,
	"./ic_hide_dark.svg": 47955,
	"./ic_highlight_green.svg": 44296,
	"./ic_highlight_tab_active.svg": 30117,
	"./ic_horse_race.svg": 65525,
	"./ic_horse_white.svg": 17749,
	"./ic_hourglass_orange.svg": 91043,
	"./ic_huawei_gallery.svg": 63924,
	"./ic_iddaa_little_finger.svg": 8958,
	"./ic_im.svg": 4922,
	"./ic_image.svg": 96571,
	"./ic_important_bullhorn.svg": 72065,
	"./ic_info.svg": 27144,
	"./ic_info_black.svg": 32212,
	"./ic_info_circle_bordered_black.svg": 43879,
	"./ic_info_circle_green.svg": 19567,
	"./ic_info_circle_grey.svg": 81927,
	"./ic_info_dark.svg": 98863,
	"./ic_info_dark_white.svg": 69865,
	"./ic_info_darkgrey.svg": 39858,
	"./ic_info_exclam.svg": 54999,
	"./ic_info_exclamation.svg": 21474,
	"./ic_info_filled.svg": 88947,
	"./ic_info_gray.svg": 806,
	"./ic_info_green.svg": 29932,
	"./ic_info_grey.svg": 46162,
	"./ic_info_light_white.svg": 38407,
	"./ic_info_lightgray.svg": 15756,
	"./ic_info_main_green.svg": 40284,
	"./ic_info_modal_new.svg": 97393,
	"./ic_info_neutral_filled.svg": 84307,
	"./ic_info_orange.svg": 69017,
	"./ic_info_outline_v2.svg": 51826,
	"./ic_info_red.svg": 24684,
	"./ic_info_theme.svg": 67518,
	"./ic_info_warning_black.svg": 35217,
	"./ic_info_warning_white.svg": 79623,
	"./ic_info_white.svg": 38226,
	"./ic_info_yellow.svg": 57587,
	"./ic_information_circle.svg": 40317,
	"./ic_injury.svg": 71545,
	"./ic_insufficient_funds.svg": 93688,
	"./ic_interactive_game.svg": 37173,
	"./ic_jockey_star.svg": 62076,
	"./ic_ko.svg": 20514,
	"./ic_large_liderler.svg": 76931,
	"./ic_large_search.svg": 46920,
	"./ic_large_search_input.svg": 16073,
	"./ic_left_arrow_white.svg": 14651,
	"./ic_like.svg": 11781,
	"./ic_like_empty.svg": 18387,
	"./ic_like_fill.svg": 74499,
	"./ic_link_copied.svg": 42291,
	"./ic_link_copy.svg": 28328,
	"./ic_link_share.svg": 49956,
	"./ic_live.svg": 58986,
	"./ic_live_icon.svg": 45182,
	"./ic_live_score_new.svg": 79034,
	"./ic_live_stack_circle.svg": 35394,
	"./ic_live_stream.svg": 5097,
	"./ic_lmt_pin.svg": 79563,
	"./ic_lock.svg": 94489,
	"./ic_logo_white.svg": 55859,
	"./ic_lost-icon.svg": 55192,
	"./ic_mail.svg": 26121,
	"./ic_match_card_search.svg": 98711,
	"./ic_megafone.svg": 70048,
	"./ic_membership.svg": 24892,
	"./ic_menu_agf.svg": 78094,
	"./ic_menu_authors.svg": 95756,
	"./ic_menu_chance_games.svg": 124,
	"./ic_menu_fixed.svg": 79106,
	"./ic_menu_horse.svg": 49763,
	"./ic_menu_interactive_game.svg": 53133,
	"./ic_menu_reported_suspended.svg": 68151,
	"./ic_menu_results.svg": 55614,
	"./ic_menu_scratch_card.svg": 31479,
	"./ic_menu_tv.svg": 67110,
	"./ic_menu_upcoming.svg": 52618,
	"./ic_menu_virtual_bet.svg": 15061,
	"./ic_messages.svg": 40960,
	"./ic_milli_piyango.svg": 28271,
	"./ic_minus.svg": 83740,
	"./ic_miss_penalty.svg": 35622,
	"./ic_mobile_game_search.svg": 85342,
	"./ic_modal_close_x.svg": 9695,
	"./ic_moon.svg": 43903,
	"./ic_moon_white.svg": 90905,
	"./ic_mp.svg": 66571,
	"./ic_mp_footer.svg": 42967,
	"./ic_mp_my_coupon.svg": 51125,
	"./ic_mp_result.svg": 22929,
	"./ic_mute_user_hidden.svg": 34950,
	"./ic_muted_user.svg": 73229,
	"./ic_mybalance_wallet.svg": 28758,
	"./ic_nav_authors.svg": 93766,
	"./ic_nav_coupons.svg": 35735,
	"./ic_nav_fire.svg": 64202,
	"./ic_nav_iddaa_finger.svg": 89839,
	"./ic_nav_mp.svg": 9437,
	"./ic_nav_multiple_match.svg": 21484,
	"./ic_nav_score.svg": 81584,
	"./ic_nav_sportoto.svg": 15120,
	"./ic_nav_tribun.svg": 40660,
	"./ic_nav_watch_green.svg": 38663,
	"./ic_navbar_live.svg": 13995,
	"./ic_navbar_tickets.svg": 9224,
	"./ic_new_bulletin_search.svg": 16615,
	"./ic_new_plus.svg": 3241,
	"./ic_no_coupon.svg": 8522,
	"./ic_non_highlight.svg": 62536,
	"./ic_nonwithdrawable_balance.svg": 59702,
	"./ic_normal_questionmark.svg": 96727,
	"./ic_not_found.svg": 79462,
	"./ic_not_login_winlost.svg": 15600,
	"./ic_odd_change.svg": 41514,
	"./ic_odd_down.svg": 58350,
	"./ic_odd_rate_change_arrow_down.svg": 61784,
	"./ic_odd_rate_change_arrow_up.svg": 10507,
	"./ic_odd_up.svg": 1989,
	"./ic_open_accordion.svg": 75047,
	"./ic_open_accordionGray.svg": 60974,
	"./ic_open_accordion_colored.svg": 24048,
	"./ic_open_comment.svg": 4686,
	"./ic_other_bets_change.svg": 97452,
	"./ic_party_popper.svg": 97573,
	"./ic_period.svg": 1863,
	"./ic_phone.svg": 5104,
	"./ic_phone_new.svg": 23107,
	"./ic_photo-icon.svg": 40746,
	"./ic_photo.svg": 25000,
	"./ic_pin.svg": 44321,
	"./ic_pin_dark.svg": 37112,
	"./ic_play-v2.svg": 96999,
	"./ic_play.svg": 11994,
	"./ic_play_circle.svg": 91513,
	"./ic_play_failure.svg": 10049,
	"./ic_player_off.svg": 46349,
	"./ic_player_on.svg": 98681,
	"./ic_plus.svg": 3732,
	"./ic_popular_bets.svg": 42058,
	"./ic_pre_bulletin_live_red.svg": 45640,
	"./ic_punishment_2.svg": 57072,
	"./ic_punishment_red.svg": 5163,
	"./ic_punishment_yellow.svg": 67822,
	"./ic_qr.svg": 72805,
	"./ic_question_green.svg": 66572,
	"./ic_question_mark.svg": 1040,
	"./ic_question_mark_black.svg": 90284,
	"./ic_questions.svg": 12123,
	"./ic_raffle_arrow_down.svg": 151,
	"./ic_raffle_arrow_up.svg": 48744,
	"./ic_raffle_prize.svg": 3243,
	"./ic_rank_badge_first.svg": 78645,
	"./ic_rank_badge_other.svg": 52477,
	"./ic_rank_badge_second.svg": 93945,
	"./ic_rank_badge_third.svg": 36308,
	"./ic_rank_tribun.svg": 21055,
	"./ic_rapid_market_circle.svg": 30868,
	"./ic_read_announcements.svg": 8185,
	"./ic_read_announcements_close.svg": 31792,
	"./ic_refresh.svg": 19437,
	"./ic_rename_coupon.svg": 97331,
	"./ic_report_green.svg": 58182,
	"./ic_responsible_gambling.svg": 98042,
	"./ic_responsible_gambling_mobile.svg": 55423,
	"./ic_responsible_gaming_menu.svg": 24522,
	"./ic_return_gray_bg_gray.svg": 59796,
	"./ic_right_arrow.svg": 70328,
	"./ic_right_arrow_theme.svg": 71982,
	"./ic_right_arrow_white.svg": 73762,
	"./ic_rotate.svg": 77777,
	"./ic_santra.svg": 85989,
	"./ic_save.svg": 12587,
	"./ic_save_dark.svg": 7570,
	"./ic_scratch_card.svg": 16815,
	"./ic_search.svg": 9000,
	"./ic_second_user.svg": 76342,
	"./ic_send_comment.svg": 97304,
	"./ic_setting.svg": 52368,
	"./ic_settings_wheel.svg": 82899,
	"./ic_share.svg": 86909,
	"./ic_share_black.svg": 28769,
	"./ic_share_black_white.svg": 31291,
	"./ic_share_white.svg": 78935,
	"./ic_shoe.svg": 92882,
	"./ic_show.svg": 11047,
	"./ic_show_dark.svg": 6214,
	"./ic_slider_next.svg": 31669,
	"./ic_smartbanner_bilyoner_icon.svg": 18188,
	"./ic_soccer.svg": 93497,
	"./ic_social_share_facebook.svg": 12456,
	"./ic_social_share_link.svg": 40564,
	"./ic_social_share_whatsapp.svg": 19382,
	"./ic_social_share_x.svg": 60340,
	"./ic_solid_down_arrow.svg": 25330,
	"./ic_solid_down_arrow_white.svg": 24804,
	"./ic_sort2.svg": 58306,
	"./ic_sort_dark.svg": 5063,
	"./ic_sort_new.svg": 60291,
	"./ic_spor_toto_coupon_edit.svg": 629,
	"./ic_spor_toto_delete.svg": 2101,
	"./ic_spor_toto_grey.svg": 52645,
	"./ic_spor_toto_random.svg": 90721,
	"./ic_spor_toto_transfer.svg": 92733,
	"./ic_spor_toto_winner.svg": 68433,
	"./ic_sportoto_popular.svg": 23136,
	"./ic_star.svg": 99324,
	"./ic_star_favorited.svg": 26853,
	"./ic_star_favorited_dark_green.svg": 58752,
	"./ic_stats-white.svg": 67825,
	"./ic_stop_watch.svg": 12999,
	"./ic_sub_menu_arrow.svg": 87550,
	"./ic_substitutes.svg": 33891,
	"./ic_success_page_share.svg": 75109,
	"./ic_success_page_success.svg": 21381,
	"./ic_sun.svg": 87190,
	"./ic_sun_white.svg": 13480,
	"./ic_system_coupon.svg": 79096,
	"./ic_system_laptop.svg": 30322,
	"./ic_system_phone.svg": 45954,
	"./ic_thirth_user.svg": 22121,
	"./ic_ticket_filter_down.svg": 30428,
	"./ic_ticket_lose.svg": 13744,
	"./ic_ticket_refund.svg": 68213,
	"./ic_ticket_win.svg": 39099,
	"./ic_ticket_win_author.svg": 42887,
	"./ic_time.svg": 61455,
	"./ic_time_status.svg": 98624,
	"./ic_tjk_arrow_down.svg": 48150,
	"./ic_tjk_arrow_up.svg": 62285,
	"./ic_tjk_logo.svg": 99957,
	"./ic_tjk_lose.svg": 68195,
	"./ic_tjk_tv.svg": 522,
	"./ic_tjk_win.svg": 55546,
	"./ic_trash.svg": 37418,
	"./ic_trash_dark_grey.svg": 17085,
	"./ic_trash_dark_red.svg": 94497,
	"./ic_trash_disabled.svg": 60145,
	"./ic_trash_grey.svg": 56764,
	"./ic_trash_grey_back_match.svg": 69804,
	"./ic_trash_orange.svg": 41347,
	"./ic_trash_red.svg": 82686,
	"./ic_trash_white.svg": 52588,
	"./ic_tribun.svg": 63134,
	"./ic_tribun_2.svg": 25501,
	"./ic_tribun_coupon_entry_edit.svg": 90501,
	"./ic_tribun_green.svg": 43994,
	"./ic_tribun_orange.svg": 14087,
	"./ic_tribun_refresh.svg": 16518,
	"./ic_tribun_share.svg": 17754,
	"./ic_tribun_share_green.svg": 26478,
	"./ic_tribun_share_modal.svg": 63732,
	"./ic_tribun_users.svg": 26655,
	"./ic_tribun_white.svg": 75872,
	"./ic_tv.svg": 79486,
	"./ic_tv2.svg": 54576,
	"./ic_tv_info_v2.svg": 45020,
	"./ic_tv_stack_circle.svg": 84678,
	"./ic_twitter2.svg": 44153,
	"./ic_unblock_user.svg": 54190,
	"./ic_unfollow_user.svg": 93404,
	"./ic_uniform.svg": 15356,
	"./ic_united_racing.svg": 55862,
	"./ic_up.svg": 90579,
	"./ic_up_arrow.svg": 40461,
	"./ic_up_direction.svg": 14165,
	"./ic_url.svg": 97255,
	"./ic_uv2.svg": 74565,
	"./ic_video.svg": 80445,
	"./ic_virtual_bet.svg": 53805,
	"./ic_virtual_horse_race.svg": 80601,
	"./ic_waiting.svg": 63705,
	"./ic_waiting_filled.svg": 26300,
	"./ic_waiting_orange.svg": 48354,
	"./ic_waiting_small.svg": 8721,
	"./ic_warning.svg": 28200,
	"./ic_warning_current.svg": 57510,
	"./ic_warning_exclamation.svg": 75874,
	"./ic_warning_modal.svg": 43210,
	"./ic_warning_white.svg": 39602,
	"./ic_warning_yellow.svg": 51763,
	"./ic_watch_stack_circle.svg": 81451,
	"./ic_watch_stack_circle_filled_with_text.svg": 77841,
	"./ic_weathers_snowly.svg": 23570,
	"./ic_weathers_sunny.svg": 70359,
	"./ic_whatsapp2.svg": 14760,
	"./ic_whistle.svg": 17050,
	"./ic_withdrawable_balance.svg": 86239,
	"./ic_won-icon.svg": 55478,
	"./icon-info-light-black.svg": 48274,
	"./icon-info-light.svg": 78264,
	"./icon_pin_active.svg": 17147,
	"./icon_pin_passive.svg": 80768,
	"./icon_star_active.svg": 50422,
	"./icon_star_passive.svg": 93279,
	"./icon_stats_corner.svg": 29950,
	"./icon_stats_possession.svg": 66935,
	"./icon_stats_red_card.svg": 47387,
	"./icon_stats_shot_on_target.svg": 8933,
	"./icon_stats_shrink_cards.svg": 73454,
	"./icon_stats_total_shot.svg": 74836,
	"./icon_stats_xg.svg": 37806,
	"./icon_stats_yellow_card.svg": 43730,
	"./icons-large-uzay.svg": 19895,
	"./iddaaa_logo.svg": 31729,
	"./league.svg": 97970,
	"./left-arrow-green.svg": 97676,
	"./live-filter-white.svg": 81906,
	"./live-filter-yellow.svg": 49267,
	"./modal-fail.svg": 46473,
	"./modal-success.svg": 1342,
	"./nba.svg": 61538,
	"./non_user_coupon.svg": 96481,
	"./pie.svg": 53929,
	"./predicta-modal-right-arrow.svg": 45444,
	"./predicta-right-arrow.svg": 46884,
	"./qr-android.svg": 87210,
	"./qr-apple.svg": 15679,
	"./qr-galaxy.svg": 97309,
	"./qr-huawei.svg": 9682,
	"./renovation.svg": 84478,
	"./right-arrow-red.svg": 6759,
	"./slider_right_btn.svg": 31864,
	"./spor_toto.svg": 23142,
	"./status_lose.svg": 90369,
	"./status_win.svg": 14436,
	"./team-members.svg": 7628,
	"./tjk-not-found.svg": 59185,
	"./xg-mac-karti.svg": 27700,
	"./yellow_to_red.svg": 8943,
	"./zirve-oran-new-banner-badge.svg": 72668,
	"./zirve_oran.svg": 49576
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80328;